import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux"; // Assuming you're using Redux
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Select from "../../../components/ui/Select";
import { getClientsService } from "../../../redux/services/clients_service";
import {
  assignAgentToCustomerService,
  getOrdersService,
} from "../../../redux/services/orders_service";
import { toast } from "react-toastify";

const AssignOrderModal = ({ onClose, onAssignOrder, orderId }) => {
  const dispatch = useDispatch();
  const [selectedAgent, setSelectedAgent] = useState("");
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch agents on mount
  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await dispatch(
          getClientsService({ page: 1, role: "AGENT" })
        );
        // Assuming the response has a data array of agents
        console.log(response?.payload?.data?.data?.data);
        setAgents(response?.payload?.data?.data?.data);
      } catch (error) {
        console.error("Error fetching agents:", error);
      }
    };
    fetchAgents();
  }, [dispatch]);

  const agentOptions = agents.map((agent) => ({
    value: agent?.enc_id, // Assuming agent has an id field
    label: `${agent.first_name} ${agent.last_name}`, // Adjust based on your agent object structure
  }));

  const handleSubmit = async () => {
    if (!selectedAgent) return;

    setLoading(true);
    try {
      const data = {
        agent_id: selectedAgent, // This should be the encrypted ID as per your example
      };
      await dispatch(assignAgentToCustomerService({  ...data ,customer_id: orderId }));
      onAssignOrder(); // Callback to refresh or close
      toast("تم الإسناد بنجاح");
      dispatch(getClientsService());
      onClose();
    } catch (error) {
      console.error("Error assigning order:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-elevation-3 w-full max-w-md max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3">
            <Icon name="UserCheck" size={24} className="text-primary" />
            <div>
              <h2 className="text-xl font-semibold text-foreground">
                إسناد الطلب لمندوب
              </h2>
              <p className="text-sm text-muted-foreground">
                اختر مندوب لأجل الطلب
              </p>
            </div>
          </div>

          <Button variant="ghost" size="icon" onClick={onClose}>
            <Icon name="X" size={20} />
          </Button>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="space-y-4">
            <Select
              label="اختر مندوب"
              placeholder="اختر مندوب"
              options={agentOptions}
              value={selectedAgent}
              onChange={setSelectedAgent}
              required
              searchable
            />
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between p-6 border-t border-border bg-muted/30">
          <Button
            variant="default"
            onClick={handleSubmit}
            disabled={!selectedAgent || loading}
            iconName="Check"
            iconPosition="left"
          >
            {loading ? "جاري الإسناد" : "إسناد"}
          </Button>
          <button
            variant="outline"
            onClick={onClose}
            iconName="X"
            iconPosition="left"
          >
            إلغاء
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignOrderModal;
